import type { CardChart, ChartCard } from '@/features/dashboard/api/schemas'

/** How a deep-dive card is drawn; `combo` is the home card's bars (see `ExpandedBarChart`). */
export type DeepDiveKind =
  'bar' | 'line' | 'area' | 'map' | 'waterfall' | 'hbar' | 'pie' | 'combo'

const KINDS: ReadonlySet<string> = new Set([
  'bar',
  'line',
  'combo',
  'map',
  'waterfall',
  'hbar',
  'pie',
])

/** The deep dive's chart type, else Metabase's; types with no chart (scatter, circle...) are areas. */
export const deepDiveKind = (
  card: Pick<ChartCard, 'chartType'>,
  chart: CardChart | null | undefined
): DeepDiveKind => {
  const type = chart?.chartType ?? card.chartType
  return type !== null && type !== undefined && KINDS.has(type)
    ? (type as DeepDiveKind)
    : 'area'
}

/** A table (`DataTable`) rather than a chart: it says so, or carries one. */
export const isTableCard = (
  card: Pick<ChartCard, 'chartType' | 'table'>,
  chart: CardChart | null | undefined
) =>
  card.table !== undefined || (chart?.chartType ?? card.chartType) === 'table'

/** Kinds that plot one value per category, rather than a series over time. */
export const isCategoryKind = (kind: DeepDiveKind) =>
  kind === 'waterfall' || kind === 'hbar' || kind === 'pie'
